﻿import controller from '../../../../Resources/Scripts/_Shared/Controller';
import { vehicles } from '../../_Shared/Scripts/Endpoints';

function myAimoParkSettingsPage() {

  const vehiclesList = document.querySelector('.vehicleslist');
  if (!vehiclesList) return;

  const selectedLang = document.querySelector('html').getAttribute('lang');
  const vehicleDescriptionFieldsets = document.querySelectorAll('fieldset.editdescription');
  const administrateVehicleRows = document.querySelectorAll('.myaimoparksettings__grid .gridrow');

  const clearAll = (add) => {
    for (let n = 0; n < vehicleDescriptionFieldsets.length; n++) {
      const errorDiv = vehicleDescriptionFieldsets[n].querySelector('.error');
      if (errorDiv.style.display === 'block') {
        errorDiv.innerHTML = '';
        errorDiv.style.display = 'none';
      }
      vehicleDescriptionFieldsets[n].classList.remove('editdescription--open');
      if (add) administrateVehicleRows[n].classList.add('faded');
      else administrateVehicleRows[n].classList.remove('faded');
    }
  }

  const handlePending = (pending, saveButton) => {
    if (pending) {
      saveButton.setAttribute('aria-busy', 'true');
      saveButton.setAttribute('disabled', 'true');
      saveButton.previousElementSibling.setAttribute('disabled', 'true');
    } else {
      saveButton.removeAttribute('aria-busy');
      saveButton.removeAttribute('disabled');
      saveButton.previousElementSibling.removeAttribute('disabled');
    }
  }

  vehiclesList.addEventListener('click', (event) => {
    event.preventDefault();

    const clickedVehicleFieldset = event.target.nodeName === 'A' ? event.target.parentElement.parentElement.nextElementSibling : event.target.parentElement.parentElement;
    const handleInput = (event) => event.key === 'Enter' && submitDescription(event.target.parentElement.parentElement);

    const submitDescription = async (clickedVehicleFieldset) => {
      const vehicleId = clickedVehicleFieldset.dataset.vehicleId;
      const plateText = clickedVehicleFieldset.dataset.vehiclePlateText;
      const saveButton = clickedVehicleFieldset.querySelector('.saveable');
      const inputField = clickedVehicleFieldset.querySelector('input');
      const select = clickedVehicleFieldset.querySelector('select');
      const name = inputField.value;
      const countryCode = select ? select.value : clickedVehicleFieldset.dataset.vehicleCountryCode;
      handlePending(true, saveButton);
      inputField.setAttribute('disabled', 'true');
      inputField.setAttribute('aria-busy', 'true');

      const vehicle = { vehicleId, data: { name, licensePlate: { plateText, countryCode } } };

      //const response = await apiPromise(`/booking/updatevehicle`, params, lang, 'POST').catch((err) => err);
      const response = await vehicles.updateCustomerVehicle({ bookingController: "/booking/", form: { ...vehicle } }, false, selectedLang);

      if (response.status === 200) {
        handlePending(false, saveButton);
        inputField.removeAttribute('aria-busy');

        setTimeout(() => saveButton.classList.add('complete'), 20);

        setTimeout(() => {
          clickedVehicleFieldset.previousElementSibling.querySelector('.middle').innerText = inputField.value;
          clearAll();
          inputField.removeEventListener('keyup', handleInput)
        }, 1500)
        setTimeout(() => {
          saveButton.classList.remove('complete');
          inputField.removeAttribute('disabled');
        }, 2000);

      } else {
        const errorMessageDiv = saveButton.parentElement.nextElementSibling;
        const errorMessage = response.errorMessage.includes('</strong>') ? response.errorMessage.replace('</strong>', '</strong> ') : response.errorMessage;
        errorMessageDiv.innerHTML = errorMessage;
        errorMessageDiv.style.display = "block";
        handlePending(false, saveButton);
        inputField.removeAttribute('aria-busy');
        inputField.removeAttribute('disabled');
      }
    }
    if (event.target.classList.contains('remove')) {
      clearAll();
    } else if (event.target.nodeName === 'A' && clickedVehicleFieldset && !clickedVehicleFieldset.classList.contains('editdescription--open')) {
      clearAll(true);
      const inputField = clickedVehicleFieldset.querySelector('input');
      const clickedVehicleRow = clickedVehicleFieldset.previousElementSibling;
      clickedVehicleRow.classList.remove('faded');
      clickedVehicleFieldset.classList.add('editdescription--open');
      setTimeout(() => { inputField.focus() }, 300);
      inputField.addEventListener('keyup', handleInput);

    } else if (event.target.nodeName === 'A' || event.target.classList.contains('editdescription--cancel')) {
      const inputField = clickedVehicleFieldset.querySelector('input');
      inputField.removeEventListener('keyup', handleInput);
      clearAll();
    } else if (event.target.nodeName === 'BUTTON' && clickedVehicleFieldset.querySelector('input')) {
      submitDescription(event.target.parentElement.parentElement);
    };
  });
};

controller.add('myaimopark-settings-page', myAimoParkSettingsPage);